<template>
  <v-app>
    <v-main class="primary100">
      <v-row class="d-flex flex-row align-center justify-center fill-height">
        <v-col cols="12" md="4">
          <v-card class="text-center rounded-lg">
            <v-container>
              <v-img :src="image"></v-img>
            </v-container>
            <v-card-title class="d-flex justify-center title">{{
              t("welcome")
            }}</v-card-title>
            <v-card-text class="subtitle-1">{{
              t("thanks", { name: clientName })
            }}</v-card-text>
            <v-card-text class="subtitle-1">{{ t("please") }}</v-card-text>
            <v-card-actions class="d-flex justify-center">
              <sc-btn :loading="loading" @click="confirm()">{{ t("confirm") }}</sc-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    image: require("@/assets/images/shuttle-central-illus.png"),
    clientName: null,
    token: null,
    loading: false,
  }),
  methods: {
    t(key, options = {}) {
      return this.$t(`public.emailVerification.${key}`, options);
    },
    confirm() {
      this.loading = true;
      this.API.auth
        .emailVerify({ token: this.token })
        .then(() => {
          this.$router.push('/#login');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    init() {
      try {
        const { token, lang, name } = this.$route.query;
        this.clientName = name;
        this.$root.changeLang(lang);
        this.token = token;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
